import http from "../../http-common";

const getBankAccount = async () => {
  return await http
    .get(`/account/bank-account`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createBankAccount = async (data) => {
  return await http
    .post(`/account/bank-account`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  bankAccount: {
    get: getBankAccount,
    create: createBankAccount,
  },
};

